import { Avatar } from './avatar'

interface ClinicianInfoProps {
  clinician: {
    name: string
    avatar_url?: string | null
    pod?: string | null
    clinical_manager?: string | null
  }
}

export function ClinicianInfo({ clinician }: ClinicianInfoProps) {
  return (
    <div className="flex items-start gap-4">
      <Avatar src={clinician.avatar_url || ''} alt={clinician.name} size="lg" />

      <div className="flex-1">
        <div className="text-charcoal font-medium text-sm mb-0.5">
          <span className="font-bold">Clinician:</span> {clinician.name}
        </div>

        <div className="text-charcoal font-medium text-sm mb-0.5">
          <span className="font-bold">Pod:</span> {clinician.pod ?? 'N/A'}
        </div>

        <div className="text-charcoal font-medium text-sm">
          <span className="font-bold">Clinical Manager:</span>{' '}
          {clinician.clinical_manager ?? 'N/A'}
        </div>
      </div>
    </div>
  )
}
